<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc-ch"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/06_Chapter01">Knitting know-how</a></h2>
<h2 class="toc-ch"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">Fair Isle</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Lace Border</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Anchor</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Bird</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Embroidered Flowers</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">Frog</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample">Fair Isle Border</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample">Heart</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample">Ladybird</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample">Dashes</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/17_Chapter12" title="Link target outside of Sample">Mouse</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/18_Chapter13" title="Link target outside of Sample">Little Star</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/19_Chapter14" title="Link target outside of Sample">Owl</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/20_Chapter15" title="Link target outside of Sample">Little Twists</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/21_Chapter16" title="Link target outside of Sample">Snowflake</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/22_Chapter17" title="Link target outside of Sample">Spotted Pony</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/23_Chapter18" title="Link target outside of Sample">Strawberry</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/24_Chapter19" title="Link target outside of Sample">Stripes</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/25_Chapter20" title="Link target outside of Sample">Tweed</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/26_Chapter21" title="Link target outside of Sample">Tiger Stripes</span></h2>
<div class="img_container">
<img alt="images" src="images/f004-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?63203cd4